import { AuthLoginService } from './../../auth-page/service/auth-login.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { accordionInterface } from 'src/app/util/interfaces/accordion';
import { notificationInterface } from 'src/app/util/interfaces/notification';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class NotificationPageService {
	private notificationUrl = environment.baseApiUrl + 'notifications';
	private notificationStorageUrl = environment.baseApiUrl + 'notifications/storage';
	private notificationActiveStorageUrl = environment.baseApiUrl + 'notifications/storage/active';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getNotificationsAccordion(): Observable<accordionInterface[]> {
		return this.http.get(this.notificationUrl, { headers: this.headers }).pipe(
			map((accordions: any) => {
				const newNotificationAccordionArray: accordionInterface[] = [];
				for (const accordion of accordions) {
					const newNotificationAccordion: accordionInterface = {
						id: accordion.name,
						name: accordion.name,
						notification: [],
						type: undefined,
						dataType: 'notification',
						border: '',
						alert: false,
						accordionLength: 0,
						hidden: false,
					};

					for (const notification of accordion.notification) {
						const newNotification: notificationInterface = {
							id: notification.id,
							summary: notification.summary,
							description: notification.description,
							customer: notification.customer,
							type: notification.type,
							limit_date: notification.limit_date,
						};

						newNotificationAccordion.notification.push(newNotification);
					}

					newNotificationAccordion.accordionLength = accordion.notification.length;

					newNotificationAccordionArray.push(newNotificationAccordion);
				}

				return newNotificationAccordionArray;
			})
		);
	}

	getStorageNotification(): Observable<{ id: string; customer: string }[]> {
		return this.http.get(this.notificationStorageUrl, { headers: this.headers }).pipe(
			map((notifications: any) => {
				const newNotificationArray: { id: string; customer: string }[] = [];
				for (const notification of notifications) {
					const newNotification: { id: string; customer: string } = {
						id: notification.id,
						customer: notification.customer,
					};
					newNotificationArray.push(newNotification);
				}

				return newNotificationArray;
			})
		);
	}

	getActiveNotifications(): Observable<string[]> {
		return this.http.get(this.notificationActiveStorageUrl, { headers: this.headers }).pipe(
			map((notifications: any) => {
				const newNotificationArray: string[] = [];
				for (const notification of notifications) {
					newNotificationArray.push(notification);
				}
				return newNotificationArray;
			})
		);
	}
}
